import type {CreateExtArgs} from '@wix/document-manager-core'
import type {ComponentAfterRootAddDataEvent} from '../hooks'
import type {WixCodeExtensionAPI} from '../../wixCode'
import type {ComponentCodeExtensionAPI} from '../../componentCode'

export const generateNicknamesForPageOfComponent = (
    createExtArgs: CreateExtArgs,
    data: ComponentAfterRootAddDataEvent
) => {
    const {extensionAPI, pointers} = createExtArgs
    const {componentCode} = extensionAPI as ComponentCodeExtensionAPI
    const {compToAddPointer, viewMode} = data
    const {wixCode} = extensionAPI as WixCodeExtensionAPI
    if (wixCode.isProvisioned()) {
        const pagePointer = pointers.structure.isPage(compToAddPointer)
            ? compToAddPointer
            : pointers.structure.getPageOfComponent(compToAddPointer)
        componentCode.generateNicknamesForPages([pagePointer.id], viewMode)
    }
}
